<div class="container">
    <h2>Edit Device Teltonika Name</h2>
    <mat-form-field class="input">
        <mat-label>New Name:</mat-label>
        <input matInput type="text" [(ngModel)]="name">
        @if(name != null && name != '') {
            <mat-icon matSuffix class="search-icons" (click)="clearSearch()" matTooltip="Clear" matTooltipShowDelay="500">clear</mat-icon>
        }
    </mat-form-field>
    <div class="buttons">
        <button mat-raised-button (click)="closeDialog(true)">Save</button>
        <button mat-raised-button (click)="closeDialog(false)">Cancel</button>
    </div>
</div>